export default __webpack_public_path__ + "static/media/twitter.90f92ab9.svg";